/**
 * `storage.cloud.google.com` is the Cloud Console object browser host; responses are often HTML
 * or auth flows, not raw image bytes. React Native (especially Android) fails to decode them.
 * Public GCS objects should use `storage.googleapis.com`.
 */
export function normalizeRemoteImageUriForNative(uri: string): string {
  const s = uri.trim();
  if (!s) return s;
  let out = s.replace(
    /^https:\/\/storage\.cloud\.google\.com\//i,
    'https://storage.googleapis.com/'
  );
  if (out.startsWith('http://storage.googleapis.com/')) {
    out = `https://${out.slice('http://'.length)}`;
  }
  return out;
}
